"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveWriteManifestService = exports.WriteManifestService = exports.WriteManifestError = void 0;
const effect_1 = require("effect");
const HttpClient = __importStar(require("@effect/platform/HttpClient"));
const manifest_1 = require("../manifest");
const requests_1 = require("./requests");
const resolvers_1 = require("./resolvers");
const Manifest = __importStar(require("./service"));
class WriteManifestError extends effect_1.Data.TaggedError('@fixtuur/backpack/Manifest/WriteManifestError') {
}
exports.WriteManifestError = WriteManifestError;
/**
 * Allows us, via the Manifest Service, to manually control
 * which products are explicitly published or unpublished
 * across each of our software solutions.
 */
class WriteManifestService extends effect_1.Context.Tag('@fixtuur/backpack/Services/WriteManifestService')() {
}
exports.WriteManifestService = WriteManifestService;
exports.LiveWriteManifestService = effect_1.Layer.effect(Manifest.WriteManifestService, effect_1.Effect.gen(function* (_) {
    const http = yield* _(HttpClient.HttpClient);
    const { manifestUrl } = yield* _(manifest_1.ManifestConfigService);
    const unpublishProduct = (tenant, productId, solution, token) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.UnpublishProduct)({ tenant, productId, solution, token }), (0, resolvers_1.unpublishProductResolver)(http, manifestUrl))));
    const publishProduct = (tenant, productId, solution, token) => manifestUrl.pipe(effect_1.Effect.flatMap(manifestUrl => effect_1.Effect.request((0, requests_1.PublishProduct)({ tenant, productId, solution, token }), (0, resolvers_1.publishProductResolver)(http, manifestUrl))));
    return { unpublishProduct, publishProduct };
}));
